<template>
  <tr
    :tabindex="to ? 0 : undefined"
    :role="to ? 'button' : 'row'"
    @click="handleRowClick"
    @keydown="handleKeydown"
  >
    <td v-for="(col, i) in columns" :key="i" role="cell" :data-label="col">
      <slot :name="i" />
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useRouter } from 'vue-router'
import type { RouteLocationRaw } from 'vue-router'

export default defineComponent({
  name: 'USTableRow',
  props: {
    columns: {
      type: Array as PropType<string[]>,
      required: true
    },
    to: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      default: undefined
    }
  },
  setup(props) {
    const router = useRouter()

    const handleRowClick = () => {
      if (props.to) {
        router.push(props.to)
      }
    }

    const handleKeydown = (e: KeyboardEvent) => {
      if (props.to && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault()
        router.push(props.to)
      }
    }

    return { handleRowClick, handleKeydown }
  }
})
</script>

<style lang="scss" scoped>
tr[role='button'] {
  cursor: pointer;
}
</style>
